import React from 'react';
import { Alert, AlertTitle, Box, Tabs, Tab } from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Timeline as BaselineIcon,
  MonitorHeart as MonitorIcon,
  ThumbUpAlt as GoNoGoIcon,
} from '@mui/icons-material';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import PageSkeleton from './PageSkeleton';
import { useEnvironment } from '../EnvironmentContext';

const changeRadarTabs = [
  { label: 'Dashboard', path: '/change-radar/dashboard', icon: <DashboardIcon /> },
  { label: 'Baselines', path: '/change-radar/baselines', icon: <BaselineIcon /> },
  { label: 'Monitoring', path: '/change-radar/monitoring', icon: <MonitorIcon /> },
  { label: 'Go / No-Go', path: '/change-radar/go-no-go', icon: <GoNoGoIcon /> },
];

const ChangeRadarLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { features } = useEnvironment();

  const currentTab = changeRadarTabs.findIndex((tab) =>
    tab.path === '/change-radar/dashboard'
      ? location.pathname === '/change-radar' || location.pathname === '/change-radar/dashboard'
      : location.pathname.startsWith(tab.path),
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}>
        <Tabs
          value={currentTab === -1 ? 0 : currentTab}
          onChange={(_, newValue) => navigate(changeRadarTabs[newValue].path)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ minHeight: 42 }}
        >
          {changeRadarTabs.map((tab) => (
            <Tab
              key={tab.path}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
              sx={{ minHeight: 42, py: 0, textTransform: 'none', fontSize: '0.85rem' }}
            />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {features.changeRadarPreview && (
          <Alert severity="warning" variant="outlined" sx={{ m: 2, mb: 0 }}>
            <AlertTitle>Preview — signals are sample data</AlertTitle>
            Every number on these pages is generated sample data, not live tenant telemetry. The
            Log Analytics queries Change Radar depends on are not yet registered in AYGA, so
            baselines, monitoring and go/no-go verdicts must not be used to make a real change
            decision.
          </Alert>
        )}
        {/* Keeps this section's tab bar on screen while the next tab's chunk loads. */}
        <React.Suspense fallback={<PageSkeleton />}>
          <Outlet />
        </React.Suspense>
      </Box>
    </Box>
  );
};

export default ChangeRadarLayout;


